import { cancelSubscriptionThunk } from '../../../redux/thunks/subscription';
import CustomModal from '../../modals';
import { red } from '../../../theme/themePrimitives';
import { useNavigate } from 'react-router';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

/**
 * @heading1: DeleteStageModal
 * @paragraph: A modal component to confirm the deletion of a stage.
 * Provides a warning message and actions to either cancel or confirm the deletion.
 * @param: {boolean} open - Determines whether the modal is open.
 * @param: {function} onClose - Function to handle closing the modal.
 */

const CancelSubscriptionModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    /**
     * @heading3: Variables
     * @ol:
     * dispatch: {AppDispatch} - The Redux dispatch function to trigger actions.
     * loaders/selectedStage: An object containing the details from the Redux store.
     */
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { loaders } = useSelector((state: RootState) => state.subscription);

    /**
     * @heading3: Functions
     * @heading4: Handles the deletion of the stage.
     * @paragraph: Dispatches the deleteStageThunk with the necessary parameters.
     */
    const deleteStageHandler = async () => {
        try {
            // Dispatch the thunk to delete the stage
            await dispatch(cancelSubscriptionThunk()).unwrap();
            navigate('/app/subscription');
        } catch (e) {
            // Catch errors
        }
    };

    return <CustomModal open={open} handleClose={loaders.isDeleting ? () => null : onClose} isError={true} title="Cancel Subscription">
        {/* Warning message with stage name */}
        <Typography variant="body1" align="center" mb={2}>Are you sure you want to cancel this subscription?</Typography>
        <Box borderRadius="5px" boxSizing="border-box" width="100%" display="flex" justifyContent="center" alignItems="center" p={1} bgcolor={red[100]}><Typography variant="subtitle2" align="center" color="error" fontWeight="bold">Warning: This will remove your access from all over the app.</Typography></Box>
        {/* Action buttons */}
        <Box display="flex" gap={2} mt={2}>
            <Button variant="outlined" color="error" onClick={onClose} fullWidth disabled={loaders.isDeleting}>
                Cancel
            </Button>
            <Button type="submit" variant="contained" color="error" onClick={deleteStageHandler} fullWidth disabled={loaders.isDeleting}>
                {loaders.isDeleting ? 'Removing...' : 'Remove'}
            </Button>
        </Box>
    </CustomModal>;
};

export default CancelSubscriptionModal;